'use strict';

var React = require('react');
var Add = require('../../node_modules/@material-ui/icons/Add.js');
var Button = require('../../node_modules/@material-ui/core/esm/Button/Button.js');
var Typography = require('../../node_modules/@material-ui/core/esm/Typography/Typography.js');
var withStyles = require('../../node_modules/@material-ui/core/esm/styles/withStyles.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var styles = {
  button: {
    display: 'block',
    height: 60
  },
  text: {
    "float": 'left'
  },
  addIcon: {
    "float": 'right'
  }
};

function LongAddContentButton(_ref) {
  var classes = _ref.classes,
      buttonText = _ref.buttonText,
      _onClick = _ref.onClick;
  return React__default["default"].createElement(Button["default"], {
    variant: "outlined",
    size: "large",
    color: "primary",
    fullWidth: true,
    className: classes.button,
    onClick: function onClick() {
      return _onClick();
    }
  }, React__default["default"].createElement(Typography["default"], {
    variant: "button",
    color: "primary",
    className: classes.text
  }, buttonText), React__default["default"].createElement(Add, {
    className: classes.addIcon
  }));
}

var LongAddContentButton$1 = withStyles(styles)(LongAddContentButton);

module.exports = LongAddContentButton$1;
